import React from "react";
import styles from "./VpnTypes.module.css";
const Ovpn = ({ onMainPage, item }) => {
  return (
    <div className={styles.vpnType}>
      {item?.contain?.online && <div className={styles.isOnline}></div>}
      <img src="/asets/Ovpn.svg" width={30} />
      OpenVpn
    </div>
  );
};

export default Ovpn;
